import { RestSlice } from '../../../../redux/rest.slice';
import { PendingNotice } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const cccPendingNoticeSlice = new RestSlice<PendingNotice>(
	localizationService.getLocalizedString('ccc.notices.gridTitle'),
	Resource.CccNotices
);
export default cccPendingNoticeSlice.rests.reducer;
